// extracted by mini-css-extract-plugin
export default {"brand":"style_brand__U1DY9","logo":"style_logo__vG3AF","name":"style_name__DZOfL"};